import React from "react";

export default function TopBanner(){
    return (
        <div style={{marginBottom:'30px'}}>
            <div className="topbanner">
                
                <p className="topheader"> Kalamandalam Dance School</p>
            </div>
            
        </div>
    )
}